var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Form, Input, Loader, Message } from "semantic-ui-react";
import ErrorDisplay from "../ErrorDisplay";
import { postWithAuthn } from "../RequestHelpers";
var UploadShipmentPhotosModal = /** @class */ (function (_super) {
    __extends(UploadShipmentPhotosModal, _super);
    function UploadShipmentPhotosModal(props) {
        var _this = _super.call(this, props) || this;
        _this.addImage = function (event, data) {
            var list = event.currentTarget.files;
            if (list === null || list.length === 0) {
                return;
            }
            var imageFiles = Array.from(list)
                .filter(function (f) { return f.type.match(/^image\//); });
            _this.setState(function (prevState) {
                return {
                    photos: prevState.photos.concat(imageFiles)
                };
            });
        };
        _this.submit = function () {
            _this.setState({
                loading: true,
                success: false,
            }, function () {
                var formData = new FormData();
                _this.state.photos.forEach(function (p, index) {
                    formData.append("photo-" + index, p);
                });
                postWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/shipments/id/" + encodeURIComponent(_this.props.shipmentId) + "/photos", formData)
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true,
                            errors: []
                        });
                        return;
                    }
                    else {
                        _this.setState({
                            loading: false,
                            success: false,
                            errors: [{
                                    path: '/',
                                    msg: 'An unexpected error occurred'
                                }]
                        });
                        return;
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't add photos: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            errors: [],
            photos: []
        };
        return _this;
    }
    UploadShipmentPhotosModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.errors.length > 0 },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.photos.length,
            " Photos selected",
            this.state.photos.map(function (f, index) {
                return React.createElement("div", { key: index },
                    "Photo #",
                    index + 1,
                    ": ",
                    f.name,
                    " (",
                    f.size,
                    "b, ",
                    f.type,
                    ")");
            }),
            React.createElement("div", null,
                React.createElement(Input, { type: 'file', accept: 'image/jpeg', onChange: this.addImage, multiple: true })),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Photos uploaded."),
            React.createElement(ErrorDisplay, { errors: this.state.errors, errorPath: '/' }),
            React.createElement(Button, { disabled: this.state.success || this.state.photos.length === 0, icon: 'upload', label: 'Add photos', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return UploadShipmentPhotosModal;
}(React.PureComponent));
export default UploadShipmentPhotosModal;
;
//# sourceMappingURL=UploadShipmentPhotos.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/UploadShipmentPhotos.js
// module id = 1266
// module chunks = 0